import { z } from "zod";
import { externalClientAppSchema } from "./client-attribution.js";
export const channelResourceActorSchema = z.object({
    id: z.string().trim().min(1).max(240),
    subjectId: z.string().trim().min(1).max(240).optional(),
    principalType: z.enum(["user", "service"]),
    displayName: z.string().trim().min(1).max(160).optional(),
    imageUrl: z.string().trim().url().max(2_048).refine((value) => {
        try {
            return new URL(value).protocol === "https:";
        }
        catch {
            return false;
        }
    }, "Actor image URL must use HTTPS.").optional(),
});
export const channelResourceProvenanceSchema = z.object({
    actor: channelResourceActorSchema,
    clientApp: externalClientAppSchema.optional(),
    interfaceType: z.enum(["web", "cli", "api", "mcp", "ios"]).optional(),
    executedByTwin: z.boolean().optional(),
});
export const channelAuthorshipProvenanceSchema = z.object({
    requester: channelResourceActorSchema,
    author: z.enum(["requester", "twin"]),
    executor: z.discriminatedUnion("kind", [
        z.object({ kind: z.literal("direct") }).strict(),
        z.object({
            kind: z.literal("twin"),
            sessionId: z.string().trim().min(1).optional(),
            runId: z.string().trim().min(1),
        }).strict(),
    ]),
}).strict();
export const provenanceExplanationSubjectSchema = z.discriminatedUnion("kind", [
    z.object({
        kind: z.literal("run"),
        runId: z.string().trim().min(1),
    }),
    z.object({
        kind: z.literal("channel_dashboard"),
        channelId: z.string().trim().min(1),
        viewId: z.string().trim().min(1).optional(),
        objectTypeId: z.string().trim().min(1).optional(),
        widgetId: z.string().trim().min(1).optional(),
    }).superRefine((subject, ctx) => {
        if (subject.viewId || subject.objectTypeId)
            return;
        ctx.addIssue({
            code: "custom",
            message: "A dashboard trace requires viewId or objectTypeId.",
            path: ["viewId"],
        });
    }),
]);
export const requestProvenanceExplanationInputSchema = z.object({
    subject: provenanceExplanationSubjectSchema,
});
export const provenanceExplanationContentSchema = z.object({
    headline: z.string().trim().min(1).max(160),
    summary: z.string().trim().min(1).max(1_200),
    steps: z.array(z.object({
        title: z.string().trim().min(1).max(120),
        explanation: z.string().trim().min(1).max(600),
    })).min(1).max(5),
    caveats: z.array(z.string().trim().min(1).max(500)).max(5),
});
export const provenanceExplanationResponseSchema = provenanceExplanationContentSchema.extend({
    id: z.string().trim().min(1),
    subject: provenanceExplanationSubjectSchema,
    evidenceHash: z.string().trim().min(1),
    promptVersion: z.string().trim().min(1),
    provider: z.string().trim().min(1),
    model: z.string().trim().min(1),
    generatedAt: z.number().int().nonnegative(),
    cached: z.boolean(),
});
